<template>
    <span style="display: inline-block;">
        <div v-if="url == ''" class="-wrapper">
            <p class="ci ci-loading"></p>
            <p class="-ml-2 -color-while-1">{{$t('LABEL.LOADING')}}</p>
        </div>
        <button v-else @click="redirectIncident()" :disabled="isDisabled" :data-button-color="colorButton" class="buttons" data-size="s"  type="button">
            {{ $t('COMPLIANCE.BUTTON.VIEW_INCIDENT') }}
        </button>
    </span>
</template>

<script>
    export default {
        name: 'DetailButton',
        props: {
            rule: {
                type: Object,
                default: {}
            },
            cmpnId: {
                type: String,
                default: ''
            },
            user: {
                type: Object,
                default: {}
            },
            rsltId: {
                type: String,
                default: ''
            },
            dataSize: {
                type: String,
                default: ''
            },
            doneIncident: {
                type: Function,
                default: () => {}
            },
        },
        data: function() {
            return {
                url: '',
                statusCode: 0,
                colorButton: '',
                isDisabled: false
            }
        },
        created() {
            this.getURLRedirect();
        },
        methods: {
            getURLRedirect() {
                if (!this.rule.url) {
                    const portalCmpnId = this.cmpnId;
                    const portalUserId = this.user.userId;
                    const svcId = this.constants.SERVICE.GOVERNANCE;
                    let eventId = svcId + '_' + this.rsltId + '_' + this.rule.ruleId;
                    let itgrMappId = svcId + '_' + this.rule.plcyId + '_' + this.rule.ruleId;

                    let body = {
                        eventId: eventId,
                        itgrMappId: itgrMappId
                    };
                    const url = `/api/external/${portalCmpnId}/${portalUserId}/incdnt`;
                    this.http.post(url, body).then(result => {
                        if (result.data.status == 'ok' && result.data.data.url !== '') {
                            this.url = result.data.data.url;
                            this.statusCode = result.data.data.statusCode;
                            this.isDisabled = false;
                        } else {
                            this.url = null;
                            this.statusCode = 10001;
                            this.isDisabled = true;
                        }
                        this.checkColorButton();
                        this.doneIncident({
                            ruleId: this.rule.ruleId,
                            url: this.url,
                            statusCode: this.statusCode,
                            isDisabled: this.isDisabled
                        });
                    }).catch(error => {
                        this.url = null;
                        this.statusCode = 10001;
                        this.checkColorButton();
                        this.isDisabled = true;

                        this.doneIncident({
                            ruleId: this.rule.ruleId,
                            url: this.url,
                            statusCode: this.statusCode,
                            isDisabled: this.isDisabled
                        });
                    });
                } else {
                    this.url = this.rule.url;
                    this.statusCode = this.rule.statusCode;
                    this.isDisabled = this.rule.isDisabled;
                    this.checkColorButton();
                }
                
            }, 
            redirectIncident() {
                if (this.url != '' && this.url != null) {
                    window.open(this.url, '_blank');
                }
            },
            checkColorButton() {
                let colorButton = '';
                switch (this.statusCode) {
                    case "10001":
                        colorButton = 'red-1';
                        break;
                    case "10002":
                        colorButton = 'blue-2';
                        break;
                    case "10003":
                        colorButton = 'gray-2';
                        break;
                    default:
                        colorButton = 'red-1';
                        break;
                }
                this.colorButton =  colorButton;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/compliance/widget/DetailButton.vue